export default {"src":"/_next/static/media/icon-bicycle-green.7c88bc68.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};